/**
 * Find A Home
 */
var findAHome = new function() {
   var self = this,
   	  mobileInit = false,
      searchClicked = false,
      m_internationalization = window.internationalization,
      oForm = new PageForm('#PageBody', '/findahome.c21', 'FindAHomeSearch', {listTypeNewListingsSelect:'1'}, true, true),
      updateC21HoverState = function () {
         $("label.c21hoverstate").each(function() {
            var jLabel = $(this),
               strFor = jLabel.attr('for'),
               jInput = jLabel.find('#' + strFor);

            if (jInput.is(":checked")) {
               jLabel.addClass('checked');
            } else {
               jLabel.removeClass('checked');
            }
         });
      },

      initC21HoverState = function () {
         $("label").each(function() {
            var jLabel = $(this),
               strFor = jLabel.attr('for'),
               jInput;

            if (strFor) {
               jInput = jLabel.find('#' + strFor);
            } else {
               return;
            }

            if (jInput.length == 0) {
               return;
            }

            jLabel.addClass('c21hoverstate');
               
            jInput.change(updateC21HoverState);

            jLabel.hover(function() {
               if (!jInput.attr("disabled")) {
                  jLabel.addClass('hover');
               }
            }, function() {
               jLabel.removeClass('hover');
            });
         });
      },
      
      /**
       * Expand Additional Search Options
       * 
       */
      expandOptions = function() {
           $("#showOptions").val("Y"); 
           $("#findAHomePropertyDetails .collapsableHeader").removeClass("expand");
           $("#findAHomePropertyDetails .collapsableHeader").addClass("collapse");
           $("#findAHomePropertyDetails .actionHeader").html(m_internationalization.getString("Collapse Options"));
           $("#findAHomePropertyDetails #propertyEssential").show();
           $("#findAHomePropertyDetails #propertyAdditional").show();
           $("#findAHomePropertyDetails .findHomeBtm").show();
           $("#findAHomePropertyDetails").css("border-bottom", "1px solid #ddd");
           $("#findAHomePropertyDetails .collapsableHeader").css("height", "35px");
      },
      
      /**
       * Collapse Additional Search Options
       * 
       */
      collapseOptions = function() {
    	  //alert(m_internationalization.getString("Expand Options"));
           $("#showOptions").val("N");
           $("#findAHomePropertyDetails .collapsableHeader").removeClass("collapse");
           $("#findAHomePropertyDetails .collapsableHeader").addClass("expand");
           $("#findAHomePropertyDetails .actionHeader").html(m_internationalization.getString("Expand Options"));
           $("#findAHomePropertyDetails #propertyEssential").hide();
           $("#findAHomePropertyDetails #propertyAdditional").hide();
           $("#findAHomePropertyDetails .findHomeBtm").hide();
           $("#findAHomePropertyDetails").css("border-bottom", "none");
           $("#findAHomePropertyDetails .collapsableHeader").css("height", "36px");
      };
   
   this.initialize = function() {
	  //m_internationalization.initialize();
      this.setSearchTab(); 
      this.initGATrackers();
      $("#listTypeForSale, #listTypeForRent").click(this.listTypeForSaleClicked);
      $("#listTypeOpenHouses").click(this.listTypeOpenHousesClicked);
      $("#PageBody select, #PageBody input:checkbox, #PageBody input:radio").not("#listTypeNewListingsDiv select").uniform();
      $("#listTypeNewListingsDiv select").uniform({
         selectClass: 'selector smallSelector'
      });
      this.listTypeForSaleClicked();
      this.loadCookie();
      this.listTypeOpenHousesClicked();
      this.listTypeNewListingsClicked();
      initPropertyTypes();
      initInfoBubbles();

      $('html').bind('keypress', function(e)
      {
           if(e.keyCode == 13)
           {
               //Trigger a search
               e.preventDefault();
               $("#searchButton1").click();
               return;
           }
      });      

      initC21HoverState();
      updateC21HoverState();
      this.initializeAutocomplete();
      this.initAdditionalSearchOptions();
      
      // Mobile      
      self.initMobile();
      $(window).on('enterResponsivePhone', function() { 
         self.initMobile();
         mobileInit = true;
      });      
   };
   
   /**
    * Mobile only functionality
    * 
    */
   this.initMobile = function() {
	  if(window.responsiveMode.getMode() != 1) {
	     return;  
	  } 
	   
	  $("#propertyTypes.toggleSection, #propertySize.toggleSection, #listingTypes.toggleSection").show(); 
	  $("#propertyEssential.toggleSection").removeClass('collapse');
	  
	  if($("#showMobileRefineOptions").val() != 'Y') {
	     $(".refineTab.additionalOptions").addClass('collapse');
	     $("#propertyEssential.toggleSection").addClass('collapse');
	  } 	   
	   
	  if($("#showMobilePropTypes").val() != 'Y') {
	     $(".refineTab.propTypes").addClass('collapse');
	     $("#propertyTypes.toggleSection").hide();
	  } 	   
	  
	  if($("#showMobileAddOptions").val() != 'Y') {
	     $(".refineTab.moreOptions").addClass('collapse');
	     $("#propertySize.toggleSection").hide();
	  } 	   
	  
	  if($("#showMobileListTypes").val() != 'Y') {
	     $(".refineTab.listTypes").addClass('collapse');
	     $("#listingTypes.toggleSection").hide();
	  } 	   
	  
	  // do not initialize clicks if already initialized
	  if(mobileInit) {
	     return;
	  }
	  
	  mobileInit = true;
	  $(".refineTab.additionalOptions").live( "click", function() {
	     if($(this).hasClass('collapse')) {
	        $(this).removeClass('collapse');     
	        $("#propertyEssential.toggleSection").removeClass('collapse');
	        $("#showMobileRefineOptions").val("Y");
		 } else {
	        $(this).addClass('collapse');
	        $("#propertyEssential.toggleSection").addClass('collapse');
	        $("#showMobileRefineOptions").val("N");
		 }
	  });   
	  
	  $(".refineTab.propTypes").live( "click", function() {
	     if($(this).hasClass('collapse')) {
	        $(this).removeClass('collapse');     
	        $("#propertyTypes.toggleSection").show();
	        $("#showMobilePropTypes").val("Y");
		 } else {
	        $(this).addClass('collapse');
	        $("#propertyTypes.toggleSection").hide();
	        $("#showMobilePropTypes").val("N");
		 }
	  });
	  
	  $(".refineTab.moreOptions").live( "click", function() {
	     if($(this).hasClass('collapse')) {
	        $(this).removeClass('collapse');     
	        $("#propertySize.toggleSection").show();
	        $("#showMobileAddOptions").val("Y");
		 } else {
	        $(this).addClass('collapse');
	        $("#propertySize.toggleSection").hide();
	        $("#showMobileAddOptions").val("N");
		 }
	  });
	  
	  $(".refineTab.listTypes").live( "click", function() {
	     if($(this).hasClass('collapse')) {
	        $(this).removeClass('collapse');     
	        $("#listingTypes.toggleSection").show();
	        $("#showMobileListTypes").val("Y");
		 } else {
	        $(this).addClass('collapse');
	        $("#listingTypes.toggleSection").hide();
	        $("#showMobileListTypes").val("N");
		 }
	  });  
   }
     
   this.initGATrackers = function() {
	   if(!searchClicked) {
	      $("#bedroomsFrom").live('change', function() {
	         Track.doEvent('Find a Home', 'Search by Features', 'Select Bedrooms From', parseInt($(this).val())); 
	      });
	      
	      $("#bedroomsTo").live('change',function() {
	       	 Track.doEvent('Find a Home', 'Search by Features', 'Select Bedrooms To', parseInt($(this).val())); 
	      });
	      
	      $("#bathroomsFrom").live('change', function() {
	      	 Track.doEvent('Find a Home', 'Search by Features', 'Select Baths From', parseInt($(this).val())); 
	      });

	      $("#bathroomsTo").live('change', function() {
	       	 Track.doEvent('Find a Home', 'Search by Features', 'Select Baths To', parseInt($(this).val())); 
	      });
	      
		  $("#fahPriceFrom").live('change', function() {
			 Track.doEvent('Find a Home', 'Search by Features', 'Select Price From');
		  });
		  
		  $("#fahPriceTo").live('change', function() {
		     Track.doEvent('Find a Home', 'Search by Features', 'Select Price To');
		  }); 
		  
		  $("#structureSizeFrom").live('change', function() {
		     Track.doEvent('Find a Home', 'Search by Features', 'Select Structure Size From');
		  });

		  $("#structureSizeTo").live('change', function() {
			 Track.doEvent('Find a Home', 'Search by Features', 'Select Structure Size To');
		  });

		  $("#lotSizeFrom").live('change', function() {
			 Track.doEvent('Find a Home', 'Search by Features', 'Select Lot Size From');
		  });

		  $("#lotSizeTo").live('change', function() {
		     Track.doEvent('Find a Home', 'Search by Features', 'Select Lot Size To');
		  });
		
		  $("#yearBuiltFrom").live('change', function() {
		     Track.doEvent('Find a Home', 'Search by Features', 'Select Year Built From');
		  });

		  $("#yearBuiltTo").live('change', function() {
		     Track.doEvent('Find a Home', 'Search by Features', 'Select Year Built To');
		  });
	  }
	   	   
      $("#listTypeForSale").click(function() {
    	 if($(this).attr("checked")) {
    	    Track.doEvent('Find a Home', 'Search by Features', 'Select For Sale');   	 
    	 } else {
    		Track.doEvent('Find a Home', 'Search by Features', 'Deselect For Sale');   
    	 }
      });
         
      $("#listTypeForRent").click(function() {
     	 if($(this).attr("checked")) {
     	    Track.doEvent('Find a Home', 'Search by Features', 'Select For Rent');   	 
     	 } else {
     	    Track.doEvent('Find a Home', 'Search by Features', 'Deselect For Rent');   
     	 }
      });
      
      $("#listTypeForeclosures").click(function() {
      	 if($(this).attr("checked")) {
      	    Track.doEvent('Find a Home', 'Search by Features', 'Select Foreclosures');   	 
      	 } else {
      	    Track.doEvent('Find a Home', 'Search by Features', 'Deselect Foreclosures');   
      	 }
      });
      
      $("#listTypeRecentlyReduced").click(function() {
       	 if($(this).attr("checked")) {
       	    Track.doEvent('Find a Home', 'Search by Features', 'Select Recently Reduced');   	 
       	 } else {
       	    Track.doEvent('Find a Home', 'Search by Features', 'Deselect Recently Reduced');   
       	 }
      });
               
      $("#listTypeSalePending").click(function() {
    	 if($(this).attr("checked")) {
    	    Track.doEvent('Find a Home', 'Search by Features', 'Select Sale Pending');   	 
    	 } else {
    	    Track.doEvent('Find a Home', 'Search by Features', 'Deselect Sale Pending');   
    	 }
      });      
      
      $("#listTypeOpenHouses").click(function() {
      	 if($(this).attr("checked")) {
      	    Track.doEvent('Find a Home', 'Search by Features', 'Select Open Houses');   	 
      	 } else {
      	    Track.doEvent('Find a Home', 'Search by Features', 'Deselect Open Houses');   
      	 }
      });    		  
      
      $("#listTypeNewListings").click(function() {
       	 if($(this).attr("checked")) {
       	    Track.doEvent('Find a Home', 'Search by Features', 'Select New Listings');   	 
       	 } else {
       	    Track.doEvent('Find a Home', 'Search by Features', 'Deselect New Listings');   
       	 }
      });
      
      $("#listTypeC21Only").click(function() {
         if($(this).attr("checked")) {
            Track.doEvent('Find a Home', 'Search by Features', 'Select C21 Listings Only');   	 
         } else {
            Track.doEvent('Find a Home', 'Search by Features', 'Deselect C21 Listings Only');   
         }    	  
      });            
      
      $("#listTypeNewListingsSelect").change(function() {
    	 Track.doEvent('Find a Home', 'Search by Features', 'Select New Listings Within Weeks', parseInt($(this).val()));  
      });
      
      $(".propTypeCheckbox").click(function() {
    	 if($(this).attr('checked')) {
    	    Track.doEvent('Find a Home', 'Search by Features', 'Select Property Type', parseInt($(this).attr("id").substr(12)));  
    	 } else {
    		Track.doEvent('Find a Home', 'Search by Features', 'Deselect Property Type', parseInt($(this).attr("id").substr(12)));  
    	 }    	 
      });
   }
   
   /**
    * Set the Property Search Tab
    * 
    */
   this.setSearchTab = function() {
      $("#findAHomeSearchTabs .searchTab.bypropfeatures, #findAHomeSearchNav .searchByFeature").addClass("selected");      
   }
      
   this.loadCookie = function() {
      var cookie = portalAjax.getCookie("FINDAHOME_SEARCH");
      if(cookie != null && cookie.length > 0) {
         var params = c21Helpers.queryToJSON(cookie);     
         if(params != null) {
            $("#location").val(params.LOCATION);
            $("#fahPriceFrom").val(params.FAHPRICEFROM);
            $("#fahPriceTo").val(params.FAHPRICETO);
            $("#bedroomsFrom").val(params.BEDROOMSFROM);
            $("#bedroomsTo").val(params.BEDROOMSTO);
            $("#bathroomsFrom").val(params.BATHROOMSFROM);
            $("#bathroomsTo").val(params.BATHROOMSTO);
            $("#structureSizeFrom").val(params.STRUCTURESIZEFROM);
            $("#structureSizeTo").val(params.STRUCTURESIZETO);
            $("#lotSizeFrom").val(params.LOTSIZEFROM);
            $("#lotSizeTo").val(params.LOTSIZETO);
            $("#yearBuiltFrom").val(params.YEARBUILTFROM);
            $("#yearBuiltTo").val(params.YEARBUILTTO);
            
            var propertytypes = params.SELECTEDPROPERTYTYPES;
            $("#selectedPropertyTypes").val(propertytypes);
            
            var forsale = params.LISTTYPEFORSALE;
            var forrent = params.LISTTYPEFORRENT;
              jForSaleRadioDiv = $('#listTypeForSaleRadioDiv');
              jForSaleRadio = jForSaleRadioDiv.find("input");
            if(forrent != 'on') {
               $("#listTypeForSale").attr("checked", true);
               $("#listTypeForRent").attr("checked", false);
               if(params.LISTTYPEFORSALERADIO == 'New Construction') {
                  $("#ncForSale").attr("checked", true); 
               } else if (params.LISTTYPEFORSALERADIO == 'Resale') {
                  $("#resaleForSale").attr("checked", true);   
               } else {
                  $("#allForSale").attr("checked", true);   
               }
                jForSaleRadioDiv.removeClass('disableDiv');
                jForSaleRadio.removeAttr('disabled');
            } else {
               $("#listTypeForSale").attr("checked", false);
               $("#listTypeForRent").attr("checked", true);
                 jForSaleRadioDiv.addClass('disableDiv');
                 jForSaleRadio.attr('disabled', true);
            }

            if(params.LISTTYPEFORECLOSURES == 'on') {
               $("#listTypeForeclosures").attr("checked", true);              
            }
            if(params.LISTTYPERECENTLYREDUCED == 'on') {
               $("#listTypeRecentlyReduced").attr("checked", true);              
            }
            if(params.LISTTYPESALEPENDING == 'on') {
               $("#listTypeSalePending").attr("checked", true);               
            }
            if(params.LISTTYPENEWLISTINGS == 'on') {
               $("#listTypeNewListings").attr("checked", true);               
               if(params.LISTTYPENEWLISTINGSSELECT != undefined) {
                  $("#listTypeNewListingsSelect").val(params.LISTTYPENEWLISTINGSSELECT);
               }
            }
            if(params.LISTTYPEOPENHOUSES == 'on') {
               $("#listTypeOpenHouses").attr("checked", true);             
               if(params.LISTTYPEOPENHOUSESRADIO == 'This Weekend') {
                  $("#thisWeekendOpenHouse").attr("checked", true);              
               } else if(params.LISTTYPEOPENHOUSESRADIO == 'Today') {
                  $("#todayOpenHouse").attr("checked", true);                             
               } else {
                  $("#allOpenHouse").attr("checked", true);
               }
            }
            if(params.LISTTYPEC21ONLY == 'on') {
               $("#listTypeC21Only").attr("checked", true);             
            }
            
            initC21HoverState();
            updateC21HoverState();
            $.uniform.update();
         }     
      }
   }
   
   /**
    * Initialize Additional Search Options
    * 
    */
   this.initAdditionalSearchOptions = function() {
     // Expand or Collapse Options 
     var showOptions = $("#showOptions").val();
     if(showOptions == "Y") {
        expandOptions();     
     } else {
       collapseOptions();
     }
     
      $("#findAHomePropertyDetails .collapsableHeader .actionHeader, #findAHomePropertyDetails .collapsableHeader  .actionImage").click(function() {
        if($("#findAHomePropertyDetails .collapsableHeader").hasClass("collapse")) {
           Track.doEvent('Find a Home', 'Search by Features', 'Collapse Options');   
           collapseOptions();
        } else {
           Track.doEvent('Find a Home', 'Search by Features', 'Expand Options');	
           expandOptions();
        }
      }); 
   }
   
   this.showDisambiguation = function() {
      var jDrop = $("#findahomeDropdownContent");
      
      if (!jDrop.filter(":visible").length) {
         jDrop.slideDown();
      }
   }

   function initInfoBubbles () {
      $("#topQuestionIcon, #bottomQuestionIcon").qtip({
         content: {
            text: $("#infoTextBubble").html()
         }, 
         position: {
            target: 'event',
            my: 'center right', // Use the corner...
            at: 'center left', // ...and opposite corner
            viewport: $(window)
         }, 
         style: {
            tip: {
               border: 10,
               width: 18,
               height: 30,
               offset: 10,
               mimic: 'center'
            }, 
            classes: 'ui-tooltip-shadow ui-tooltip-' + 'tipsy'
         }, 
         onUpdateCalled: function(api, actualCorner, position) {
            // The 'actualCorner' attribute is not in the qTip documentation
            // because it was added in lieu of an alternative
            //
            // Here we are repositioning the tip so the 'mimic' arrow
            // is pointing in the correct location
            if (actualCorner.y == 'top') {
               position.top -= 29;
            } else if (actualCorner.y == 'bottom') {
               position.top += 29;
            }
         }, 
         prerender: true
      });
   }
   
   //Property types
   /* Checks if other property types are checked */
   function propertyTypesSelected() {
     var propertyTypeSelected = false;
     $(".propTypeCheckbox").each(function() {
        var id = $(this).attr('id');   
        if($("#" + id).attr("checked")) {
           propertyTypeSelected = true;   
        }          
     });
     return propertyTypeSelected;
   };
   
   /* Function called when other property type has been clicked */
   this.otherPropertyTypeClicked = function () {
    //check any if all the other property types are not checked
    if(propertyTypesSelected() == true) {
       //Uncheck any
      $("#anyPropertyType").attr("checked", false);
    } else {
       //Uncheck any
      $("#anyPropertyType").attr("checked", true);
    }
     updateC21HoverState();
     $.uniform.update();
   };
   
   function clickOtherPropertyType() {
    //check any if all the other property types are not checked
    if(propertyTypesSelected() == true) {
       //Uncheck any
      $("#anyPropertyType").attr("checked", false);
    } else {
       //Uncheck any
      $("#anyPropertyType").attr("checked", true);
    }
     updateC21HoverState();
     $.uniform.update();
  }
   
   /* Init Property types */
   function initPropertyTypes () {
     var selectedPropertyTypes = $("#selectedPropertyTypes").val();
     if(selectedPropertyTypes != null && selectedPropertyTypes.length > 0) {
       var mySplitResult = selectedPropertyTypes.split(",");
       $.each(mySplitResult, function(key, value) {
         if (value && value.length) {
            $("#" + value).attr("checked", true);
         }
       });
     }   
     clickOtherPropertyType();
     updateC21HoverState();
     $.uniform.update();
   };
   
   /* Deselect all the property types */
   function deselectAllPropertyTypes() {
     $(".propTypeCheckbox").each(function() {
        var id = $(this).attr('id');   
        $("#" + id).attr("checked", false);
     });
   };
   
   /* Function called when any property type has been clicked */
   this.anyPropertyTypeClicked = function () {
	 Track.doEvent('Find a Home', 'Search by Features', 'Select Any Property Type');  
     if($("#anyPropertyType").attr("checked")) {
       //Uncheck all the other property types
       deselectAllPropertyTypes();
     } else {
        //check any if all the other property types are not checked
       if(propertyTypesSelected() == true) {
          //Uncheck any
         $("#anyPropertyType").attr("checked", false);
       } else {
          //Uncheck any
         $("#anyPropertyType").attr("checked", true);
       }
     }      
      updateC21HoverState();
      $.uniform.update();
   };    
      
   this.searchByMap = function() {
      // TODO
   };
      
   //ListType: For Sale
   this.listTypeForSaleClicked = function() {
      var jForSale = $("#listTypeForSale"),
          jForRent = $("#listTypeForRent"),
          bForSale = true,
          jForSaleRadioDiv = $('#listTypeForSaleRadioDiv'),
          jForSaleRadio = jForSaleRadioDiv.find("input"),
          jForSaleRadioChecked = jForSaleRadioDiv.find("input:checked"),
          id = this.id;
      if (!jForSaleRadioChecked.length) {
         $(jForSaleRadio[0]).attr("checked", true);
      }
      if ((id == 'listTypeForSale' && !jForSale.attr("checked")) || id == 'listTypeForRent' && jForRent.attr("checked")) {
         bForSale = false;
      }
      jForSale.attr('checked', bForSale);
      jForRent.attr('checked', !bForSale);
      if (bForSale) {
         jForSaleRadioDiv.removeClass('disableDiv');
         jForSaleRadio.removeAttr('disabled');
      } else {
         jForSaleRadioDiv.addClass('disableDiv');
         jForSaleRadio.attr('disabled', true);
      }
      updateC21HoverState();
      $.uniform.update();
   };
   
   //ListType: Open Houses
   this.listTypeOpenHousesClicked = function() {
      var jRadioDiv = $('#listTypeOpenHousesRadioDiv'),
          jRadio = jRadioDiv.find("input"),
          jRadioChecked = jRadioDiv.find("input:checked");
      if (!jRadioChecked.length) {
         $(jRadio[0]).attr("checked", true);
      }
      if($('#listTypeOpenHouses').attr('checked')) {
         jRadioDiv.removeClass('disableDiv');
          jRadio.removeAttr('disabled');
      } else {
         jRadioDiv.addClass('disableDiv');
         jRadio.attr('disabled', true);
      }
      updateC21HoverState();
      $.uniform.update();
   };
   
   //ListType: New Listings
   this.listTypeNewListingsClicked = function() {
     if($('#listTypeNewListings').attr('checked')) {
        $('#listTypeNewListingsDiv').removeClass('disableDiv');
        $('#listTypeNewListingsDiv :input').removeAttr('disabled');
     } else {
        $('#listTypeNewListingsDiv').addClass('disableDiv');
        $('#listTypeNewListingsDiv :input').attr('disabled', true);
     }
     updateC21HoverState();
     $.uniform.update();
   };
   
   this.searchFindAHome = function() {
	  searchClicked = true; 
	  if($("#location").val() != null && $("#location").val() != "") {
	     Track.doEvent('Find a Home', 'Search by Features', 'Search');  
	  }
      oForm.submit();
   };
   
   this.clearFindAHome = function() {
	 Track.doEvent('Find a Home', 'Search by Features', 'Clear');    
     portalAjax.removeCookie("FINDAHOME_SEARCH");
     oForm.clear();
      $(".propTypeLabel").removeClass("checked");
      $("#anyPropertyType").attr("checked", true);
      this.listTypeForSaleClicked();
      this.listTypeNewListingsClicked();
      updateC21HoverState();
      $.uniform.update();
   };   

   this.defaultNewListings = function() {
     $("#listTypeNewListingsSelect").val("1");
     $.uniform.update();
   }
   
   //This function is called when the user selects a result from the disambiguation suggestions
   this.modifyLocation = function(loc) {
      //updates the location text box when user clicks on a location link to select it
      $("#location").autocomplete('val', loc); 
   };
   
   this.updateLocation = function(loc) {
    $("#location").autocomplete('val', loc);  
   };
   
   this.formatSearchResults = function() {
      
   };
      
   this.showSearchDrop = function() {
      $("#findahomeDropdownContent").show();
    };
    
   this.hideSearchDrop = function() {
      $("#findahomeDropdownContent").hide();
   };

   /**
    * Callback triggered when the server has suggest results
    */
   this.updateAutocomplete = function(strFilter, aOptions) {
      var jLocation = $('#location'),
         strTitle = '',
         strVal = jLocation.autocomplete('val');

      // Don't continue if the text has been changed since the callback
      if (strVal != strFilter) return;

      if (aOptions.length > 0) {
         if (aOptions[0].toLowerCase().indexOf(strFilter.toLowerCase()) == -1) {
            strTitle = 'No Results Found. Try These Suggestions:';
         }
      }

      jLocation.autocomplete('update', strTitle, strFilter, aOptions);
   }

   /**
    * Fire up the Autocompletion for locations
    */
   this.initializeAutocomplete = function(fnOnEnter) {
      var jLocation = $('#location');
      jLocation.autocomplete({
         onKeyDown: function(strFilter, bIsDirty) {
            if (strFilter == '') {
               jLocation.autocomplete('hide');
            } else {
               if (bIsDirty) {
                  portalAjax.doViewEngineAjax(
                     'FindAHomeSuggestLocation',
                     '/findahome.c21',
                     $.param({
                        location: strFilter,
                        submitted: 'true'
                     }),
                     {
                        cache: true
                     }
                  );
               }

               jLocation.autocomplete('show');
            }
         },
         containerClass: 'findHomeSearchInputs',
         maxItems: 10,
         onEnter: fnOnEnter
      });
   }

   self.updateC21HoverState = updateC21HoverState;
   self.initC21HoverState = initC21HoverState;
};
